@if (ds().orgUser && ds().rootUser) {
  <div class="profile-content-wrapper">
    <mat-card class="personal-info" appearance="raised">
      <mat-card-header>
        <mat-card-title>
          Persoonlijke gegevens
          <button mat-icon-button aria-label="Profiel bewerken" (click)="editProfile()">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="info-item">
          <h3>Voor- en achternaam</h3>
          <p class="content">
            {{ ds().orgUser.name ? ds().orgUser.name : 'Geen' }}
          </p>
        </div>
        @if (ds().publicSettings?.askBirthDay ?? false) {
          <div class="info-item">
            <h3>Geslacht</h3>
            <p class="content">
              {{ ds().orgUser.gender ? ds().orgUser.gender : 'Geen' }}
            </p>
          </div>
        }
        @if (ds().publicSettings?.askGender ?? false) {
          <div class="info-item">
            <h3>Geboortedatum</h3>
            @if (ds().orgUser.birthDate) {
              <p class="content">
                {{ ds().orgUser.birthDate.toDate() | date: 'dd-MM-yyyy' }}
              </p>
            }
            @if (!ds().orgUser.birthDate) {
              <p class="content">Geen</p>
            }
          </div>
        }
        <div class="info-item">
          <h3>Adres</h3>
          <p class="content">
            {{ streetInfo() }}
          </p>
        </div>
        <div class="info-item">
          <h3>Postcode</h3>
          <p class="content">
            {{ ds().orgUser.postal ? ds().orgUser.postal : 'Geen' }}
          </p>
        </div>
        <div class="info-item">
          <h3>Woonplaats</h3>
          <p class="content">
            {{ ds().orgUser.city ? ds().orgUser.city : 'Geen' }}
          </p>
        </div>
        <div class="info-item">
          <h3>Bijzonderheden</h3>
          @if (ds().selectedOrganisation.particularities) {
            <div class="content">
              @for (particularity of ds().selectedOrganisation.particularities; track particularity.id) {
                <div
                  class="icon"
                  [ngClass]="{ active: ds().orgUser.particularityIds.includes(particularity.id) }"
                  [matTooltip]="particularity.name"
                >
                  <mat-icon [svgIcon]="particularity.id"></mat-icon>
                </div>
              }
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="contact" appearance="raised">
      <mat-card-header>
        <mat-card-title>
          Contact
          @if (ds().rootUser.signInMethod === 'email') {
            <button mat-icon-button aria-label="E-mailadres bewerken" (click)="editContactInfo('email')">
              <mat-icon> edit </mat-icon>
            </button>
          }
          @if (ds().rootUser.signInMethod === 'phoneNumber') {
            <button mat-icon-button aria-label="Telefoonnummer bewerken" (click)="editContactInfo('phone')">
              <mat-icon> edit </mat-icon>
            </button>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="info-item">
          <h3>E-Mailadres</h3>
          <p class="content">
            {{ ds().orgUser.email ? ds().orgUser.email : 'Geen' }}
          </p>
        </div>
        <div class="info-item">
          <h3>Telefoonnummer</h3>
          <p class="content">
            {{ ds().orgUser.phoneNumber ? ds().orgUser.phoneNumber : 'Geen' }}
          </p>
        </div>
        <div class="info-item">
          <h3>
            Noodnummer{{ ds().orgUser.emergencyPhoneNumbers?.length > 1 ? 's' : '' }} ({{
              ds().orgUser.emergencyPhoneNumbers ? ds().orgUser.emergencyPhoneNumbers.length : 0
            }})
          </h3>
          @if (ds().orgUser.emergencyPhoneNumbers ? ds().orgUser.emergencyPhoneNumbers.length > 0 : false) {
            <div class="content">
              @for (phoneNumber of ds().orgUser.emergencyPhoneNumbers; track $index) {
                <div class="emergency-numbers-content">
                  <div class="emergency-numbers-number-description">
                    <p>{{ phoneNumber.name }}</p>
                    <p>{{ phoneNumber.description }}</p>
                  </div>
                  <p>{{ phoneNumber.phoneNumber }}</p>
                </div>
              }
            </div>
          }
          @if (ds().orgUser.emergencyPhoneNumbers ? ds().orgUser.emergencyPhoneNumbers.length < 1 : true) {
            <p class="content">Geen</p>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
